import styles from "./Command.module.scss";

const Education: React.FC = () => {
  return (
    <div className={styles.container}>
      <p>
        <b>BTech in Electronics and Communications</b>
        <br />
        Maharaja Agrasen Institute of Technology (8.67 CGPA) | 2020-2024
      </p>
    </div>
  );
};

export default Education;
